import React from 'react';
import {
  Box,
  Typography,
  Avatar,
  Button,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  CalendarToday as CalendarIcon,
  Add as AddIcon
} from '@mui/icons-material';
import { useAuth } from '../../../contexts/AuthContext';

const BookingHeader = ({
  onAddBooking,
  getBookingsByStatus,
  getUpcomingBookings,
  getPastBookings
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { userProfile } = useAuth();

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #1c1917 0%, #44403c 100%)',
        color: 'white',
        p: { xs: 1.5, sm: 2 },
        position: 'sticky',
        top: 0,
        zIndex: 100,
        mb: 2,
        boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar sx={{
            bgcolor: 'rgba(255,255,255,0.15)',
            width: { xs: 36, sm: 40 },
            height: { xs: 36, sm: 40 },
            backdropFilter: 'blur(10px)'
          }}>
            <CalendarIcon />
          </Avatar>
          <Box>
            <Typography 
              variant="h6" 
              fontWeight="700" 
              sx={{ 
                fontSize: { xs: '1.1rem', sm: '1.2rem' }, 
                letterSpacing: '-0.02em' 
              }}
            >
              {userProfile?.salonName || 'Mon Salon'}
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                opacity: 0.9, 
                fontSize: { xs: '0.8rem', sm: '0.85rem' }, 
                fontWeight: 500 
              }}
            >
              MES RÉSERVATIONS
            </Typography>
          </Box>
        </Box>
        {!isMobile && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onAddBooking}
            sx={{
              bgcolor: 'rgba(255,255,255,0.15)',
              color: 'white',
              backdropFilter: 'blur(10px)',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: { xs: '0.8rem', sm: '0.9rem' },
              px: { xs: 2, sm: 3 },
              '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' }
            }}
          >
            Ajouter une réservation
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default BookingHeader;